$(document).ready(function () {
  let n = $(window).width();
  const e = document.getElementById("cart-sidebar"),
    a = document.querySelectorAll(".darken-bg");
  function o() {
    i("success"),
      (0 < $(".wholesale-template").length && 769 <= n ? f : h)(),
      0 < $(".order-content").length &&
        $(".repurchase-container").find(".view-cart").addClass("active");
  }
  function d() {
    i("fail");
  }
  function i(t) {
    $(".cart-" + t)
      .fadeIn(300)
      .delay(800)
      .fadeOut();
  }
  $(".cart-template").on("click", ".close-cart", function () {
    $(e).removeClass("expanded"),
      $(a).removeClass("expanded"),
      $("body").removeClass("expanded");
  }),
    $(document).mouseup(function (t) {
      $(e).is(t.target) ||
        0 !== $(e).has(t.target).length ||
        ($(e).hasClass("expanded") &&
          ($(e).removeClass("expanded"),
          $(a).removeClass("expanded"),
          $("body").removeClass("expanded")));
    }),
    $(".cart-trigger").on("click", function () {
      $(e).addClass("expanded"),
        $(a).addClass("expanded"),
        $("body").addClass("expanded");
    }),
    $(".add-to-cart").on("click", async function () {
      let t = !0;
      var e, a, n;

      if ($(this).hasClass("active")) {
        n = $(this).closest("[data-product-variant]");
        e = $(n).attr("data-product-variant");
        e = parseInt(e);
        a = $(n).find(".product_quantity").val();
        var maxQuantity = $(n).find(".product_quantity").attr("max");
        maxQuantity = parseInt(maxQuantity);
        a = parseInt(a);

        // Check for "data-product-type" attribute or "sample-product-type" class
        var isSample =
          $(this).closest("[data-product-type]").length > 0 ||
          $(this).closest(".sample-product-type").length > 0;

        var isFreeSampleExist = false;

        await $.getJSON("/cart.js", function (cart) {
          for (j = 0; j < cart.items.length; j++) {
            if (cart.items[j].properties?.sample) {
              isFreeSampleExist = true;
            }
          }
        });

        if (isSample && isFreeSampleExist) {
          alert("Free Sample Already Exist!");
          window.location.reload();
          return false;
        }

        if (a <= maxQuantity) {
          let data = {
            id: e,
            quantity: a,
          };

          // If it's a sample, add properties to the data object
          if (isSample) {
            data.properties = { sample: true };
          }

          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function (response) {
              o();
              var productName = response.title.replace(/[^\w\s.%]|_/gi, " ");
              productName = productName.replace(/\b\w/g, function (char) {
                return char.toUpperCase();
              });
              var addToCartText = " added to your cart.";
              if ($(window).width() < 768 && productName.length <= 30) {
                productName += "<br>" + addToCartText;
              } else {
                productName += addToCartText;
              }
              $(".cart-success .banner-content p").html(productName);
            },
            error: function () {
              d();
            },
          });
          console.log(`isSample : ${isSample}`);
          isSample &&
            setTimeout(function () {
              $(".cart-link").trigger("click");
            }, 2000);
        } else {
          i("no-inventory");
        }
      } else if (t) {
        n = $("#product-info").offset().top;
        $("html,body").animate({ scrollTop: n }, 600);
        t = !1;
      }
    });

  $("#rebuy").on("click", function () {
    let a = [];
    $(".order-content")
      .find(".product")
      .each(function () {
        var t = $(this).attr("data-product-variant"),
          e = $(this).attr("data-quantity");
        t = { id: parseInt(t), quantity: parseInt(e) };
        a.push(t);
      });
    var t = { items: a };
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: t,
      dataType: "json",
      success: function (response) {
        o();
        var productName = response.items[0].title.replace(/[^\w\s.%]|_/gi, " ");
        productName = productName.replace(/\b\w/g, function (char) {
          return char.toUpperCase();
        });
        var addToCartText = " added to your cart.";
        if ($(window).width() < 768 && productName.length <= 30) {
          productName += "<br>" + addToCartText;
        } else {
          productName += addToCartText;
        }
        $(".cart-success .banner-content p").html(productName);
      },
      error: function () {
        d();
      },
    });
  });

  $("body").on("click", ".cart_update", function () {
    function formatcurency(price) {
      curencytmp = curency.replace("0.00", "0");
      return curencytmp.replace("0", price);
    }

    function numberWithCommas(number) {
      var number = number.toFixed("2");
      var parts = number.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }

    var variant_id = $(this).attr("data_id");
    var quantity = parseInt($(".quantity-" + variant_id).val());
    var priceValue = $(".updatedprice_" + variant_id)
      .closest(".product-tile.cart")
      .find(".quannew-itemPrice")
      .text();
    var numericPrice = parseFloat(
      priceValue
        .replace("Rs.", "")
        .replace(/[^\d.]/g, "")
        .trim()
    );
    var total = quantity * numericPrice;
    $("#cart_total").attr("value", total);
    $(".updatedprice_" + variant_id).attr("total", total);
    $(".updatedprice_" + variant_id).attr("actual_price", priceValue);
    $(".updatedprice_" + variant_id).text(
      formatcurency(numberWithCommas(total))
    );
    $(".updatedprice_" + variant_id)
      .closest(".product-tile.cart")
      .find(".itemQuan")
      .text("⨯ " + quantity);

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: {
        quantity: quantity,
        id: variant_id,
      },
      success: function (data) {
        // console.log(cart);
      },
    });

    var total = 0;
    $(".updatedprice").each(function () {
      var value = parseFloat($(this).attr("total"));
      total += value;
    });
    $(".total .money").text(formatcurency(numberWithCommas(total)));
    shipbarupdate(total);

    function shipbarupdate(carttotal) {
      if (shipthreshold) {
        if (shipthreshold > carttotal) {
          $(".custshipcont").text(
            $(".custshipcont").attr("custship") ?? "$15.00"
          );
          var spentremper =
            100 -
            (((shipthreshold - carttotal) * 100) / shipthreshold).toFixed(2);
          $(".shipping-bar-para").css("width", spentremper + "%");
          $(".shipping-bar-para span").text(
            `$${(shipthreshold - carttotal).toFixed(
              "2"
            )} more for free shipping`
          );
        } else {
          $(".custshipcont").text("FREE");
          $(".shipping-bar-para").css("width", "100%");
          $(".shipping-bar-para span").text("Complimentary shipping");
        }
      }
    }
  }),
    $("body").on("click", ".cart_remove", function () {
      var isCustomerLoggedIn = $("body").data("customer-logged-in");
      if (isCustomerLoggedIn === false) {
        var t = $(this).parents(".product-tile");
        p(0, $(t).data("variant-id"), 0);
      }
    }),
    $(".cart-template").on("change", ".product-cart-select", function () {
      var e = this;
      if (($(e).parent().siblings("input").val(e.value), $(u).length)) {
        var a = $(e).closest(".cart-items").find(".total-qty-cost");
        let t =
          Number(
            $(a)
              .attr("price")
              .replace(/[^0-9.-]+/g, "")
          ) * e.value;
        (t = "$" + t.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")),
          $(a).children().children().val(t);
      }
    });
  let u = document.getElementsByClassName("total-qty-cost");
  function p(t, e, a) {
    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: { quantity: a, id: e },
      success: function () {
        jQuery.ajax({
          type: "GET",
          dataType: "jsonp",
          url: "/cart.json",
          success: function (t) {
            if (0 < t.item_count) {
              if (0 < $(".wholesale-template").length && 769 <= n)
                return void f();
              h();
            } else
              $("#cart-totals-container").addClass("empty"),
                window.location.reload();
          },
          error: function () {
            $(".cart-fail-update").fadeIn(300).delay(1e3).fadeOut();
          },
        });
      },
    });
  }
  function f() {
    $.get("#wholesale-cart-items", {}, function (t) {
      window.BOLD &&
        BOLD.common &&
        BOLD.common.eventEmitter &&
        "function" == typeof BOLD.common.eventEmitter.emit &&
        BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
      t = $("<div />").html(t).find("#wholesale-cart-items");
      $("#wholesale-cart-items").replaceWith(t);
    });
  }
  function h() {
    var t = $("#cart-sidebar");
    $(t).find("#cart-totals .total").fadeOut(),
      $(t).find("#content").fadeOut(),
      $.get("#cart-sidebar", {}, function (n) {
        window.BOLD &&
          BOLD.common &&
          BOLD.common.eventEmitter &&
          "function" == typeof BOLD.common.eventEmitter.emit &&
          BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded"),
          $("#content").fadeOut("slow", function () {
            var t = $("<div />").html(n),
              e = t.find("#cart-count"),
              a = t.find("#content"),
              t = t.find("#cart-totals");

            $("#cart-count").replaceWith(e),
              $("#cart-totals").replaceWith(t),
              $("#content").replaceWith(a),
              $("#content").fadeIn("slow"),
              m();
          });
      });
  }
  function s(t, e) {
    var t = $(t).parent().find("input"),
      a = $(t).val(),
      n = $(e).attr("increment"),
      n = parseInt(n),
      o = $(e).attr("inventory"),
      o = parseInt(o);
    0 < e.length && a < o && !isNaN(a) && ((e = +$(t).val() + n), $(t).val(e));
  }

  function rrshipcalc() {
    try {
      if (typeof addtocarthook !== "undefined") {
        addtocarthook?.();
      } else {
        var carttotal = $(".total.cart-subtotal .money").text();
        var carttotalnum = parseFloat(carttotal.replace(/[^0-9.]/g, ""));
        function shipbarupdate(carttotalnum) {
          if (shipthreshold) {
            if (shipthreshold > carttotalnum) {
              $(".custshipcont").text(
                $(".custshipcont").attr("custship") ?? "$15.00"
              );
              var spentremper =
                100 -
                (
                  ((shipthreshold - carttotalnum) * 100) /
                  shipthreshold
                ).toFixed(2);
              $(".shipping-bar-para").css("width", spentremper + "%");
              $(".shipping-bar-para span").text(
                `$${(shipthreshold - carttotalnum).toFixed(
                  "2"
                )} more for free shipping`
              );
            } else {
              $(".custshipcont").text("FREE");
              $(".shipping-bar-para").css("width", "100%");
              $(".shipping-bar-para span").text("Complimentary shipping");
            }
          }
        }
        shipbarupdate(carttotalnum);
      }
    } catch (err) {
      console.log("err in addtocarthook");
    }
  }

  function r(t, e) {
    var t = $(t).parent().find("input"),
      a = $(t).val(),
      n = $(e).attr("increment"),
      n = parseInt(n);
    0 < e.length &&
      0 < a &&
      !isNaN(a) &&
      (a - n < 0 ? $(t).val(0) : ((e = +$(t).val() - n), $(t).val(e)));
  }
  function m() {
    let t = document.querySelectorAll(".progress-bar-container .progress-wrap"),
      n,
      o,
      i,
      s;
    0 < t.length &&
      jQuery.getJSON("/cart.js", function (a) {
        t.forEach((t) => {
          (n = a.total_price),
            (o = $(t).data("threshold")),
            (i = $(t).width()),
            5e3 <= a.total_price && !isNaN(n)
              ? $(t).hasClass("free-shipping") ||
                $($(t).siblings("p")).each(function (t, e) {
                  $(e).removeClass("active"),
                    $(e).hasClass("reached") && $(e).addClass("active");
                })
              : ($(t).hasClass("free-shipping") &&
                  $(t).removeClass("free-shipping"),
                $($(t).siblings("p")).each(function (t, e) {
                  $(e).removeClass("active"),
                    $(e).hasClass("not-reached") &&
                      ((s = 5e3 - n),
                      (s =
                        "$" +
                        (s / 100).toFixed(2) +
                        " Away from free shipping"),
                      $(e).html(s),
                      $(e).addClass("active"));
                }));
          var e = (n / o) * i;
          $($(t).children()).animate({ left: e }, 3e3);
        });
      });
    rrshipcalc();
    setTimeout(rrshipcalc(), 1500);
  }
  $("body").on("click", ".close-banner", function (t) {
    t.preventDefault(), $(this).closest(".banner").fadeOut(300);
  }),
    $(".cart-template:not(.template-cart .cart-landing-container .cart-template)").on(
      "click",
      ".qtyplus",
      function () {
        s(this, $(this).closest("[data-variant-id]"));
      }
    ),
    $(".cart-template:not(.template-cart .cart-landing-container .cart-template)").on(
      "click",
      ".qtyminus",
      function () {
        r(this, $(this).closest("[data-variant-id]"));
      }
    ),
    $(".wholesale-template").on("click", ".qtyplus", function () {
      s(this, $(this).closest("[data-variant-id]"));
    }),
    $(".wholesale-template").on("click", ".qtyminus", function () {
      r(this, $(this).closest("[data-variant-id]"));
    }),
    $(
      ".cart-landing-container:not(.cart-landing-container .cart-landing-container)"
    ).on("click", ".qtyplus", function (t) {
      t.preventDefault(), s(this, $(this).closest(".cart-items"));
    }),
    $(
      ".cart-landing-container:not(.cart-landing-container .cart-landing-container)"
    ).on("click", ".qtyminus", function (t) {
      t.preventDefault(), r(this, $(this).closest(".cart-items"));
    }),
    $(".product_quantity").on("keydown change", function (t) {
      $(this).width($(this).prop("scrollWidth"));
    }),
    $(".progress-bar-container .progress-wrap").length && m();
  let t = document.getElementById("transparent-header");
  function v(t) {
    t.target.form.submit();
  }
  t &&
    ($("body").addClass("read-article"),
    $("nav.global").addClass("global-transparent")),
    window.addEventListener("scroll", function () {
      t &&
        (window.scrollY > t.offsetHeight + t.offsetTop
          ? $("nav.global").hasClass("global-transparent") &&
            $("nav.global").removeClass("global-transparent")
          : $("nav.global").hasClass("global-transparent") ||
            $("nav.global").addClass("global-transparent"));
    }),
    document
      .querySelectorAll(".shopify-localization-form select")
      .forEach(function (t) {
        t.addEventListener("change", v);
      }),
    $("#mobile-search").keydown(function () {
      $(this).find("button.search-submit").hasClass("active") ||
        $(this).find("button.search-submit").addClass("active");
    });
  var c = document.querySelectorAll(".form .banner"),
    y = $(c).parent().parent();
  0 < c.length &&
    !$(y).hasClass("create") &&
    $(c).fadeIn("slow").delay(6e3).fadeOut(),
    ($.fn.isInViewport = function () {
      var t = $(this).offset().top,
        e = t + $(this).outerHeight() / 2,
        a = $(window).scrollTop(),
        n = a + $(window).height() / 2;
      return a < e && t < n;
    }),
    $(window).scroll(function () {
      $("video").each(function () {
        $(this).isInViewport() ? $(this)[0].play() : $(this)[0].pause();
      });
    }),
    $(".lazy").lazy({ effect: "fadeIn", effectTime: 800, visibleOnly: !1 });
  let l = $("#scroll-to-top");
  $(window).scroll(function () {
    300 < $(window).scrollTop()
      ? l.addClass("active")
      : $(l).hasClass("active") && l.removeClass("active");
  }),
    $("#scroll-to-top").on("click", function (t) {
      t.preventDefault(), $("html, body").animate({ scrollTop: 0 }, "300");
    });
}),
  (document.onreadystatechange = function () {
    "complete" === document.readyState && $(".loader").fadeOut();
  });

$(document).ready(function () {
  const samplesCallout = document.getElementsByClassName("sample-pop-up");

  $(".close-samples button").on("click", () => {
    $(samplesCallout).hide();
  });

  $(".sample-pop-up button.variant-state").on("click", () => {
    $(samplesCallout).hide();
  });
});
